import { Component, Prop, Vue } from 'vue-property-decorator';
import { alterQueryParam } from '@/helpers/QueryStringParameters';
/**
 * @deprecated OMSI is the only customer using or desiring this feature.
 */
@Component({
    name: 'DateFilters',
})
export default class default_1 extends Vue {
    @Prop({ default: null })
    value;
    @Prop({ default: false })
    disabled;
    get links() {
        const all = this.filterLocation(null, this.t.all);
        return [all].concat(this.dateOptions);
    }
    get dateOptions() {
        const t = this.$t('date');
        const map = {
            today: t.today,
            tomorrow: t.tomorrow,
            // week: 'This Week',
            // weekend: 'This Weekend',
            // nextWeek: 'Next Week',
            // nextWeekend: 'Next Weekend',
            // TODO Date picker.
        };
        return Object.entries(map).map(([value, label]) => this.filterLocation(value, label));
    }
    filterLocation(value, label) {
        return {
            value,
            label,
            location: alterQueryParam(this.$route, { date: value }),
        };
    }
}
